var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Box" },
    [
      _c(
        "el-card",
        { staticClass: "mb5" },
        [
          _c(
            "el-form",
            [
              _c(
                "el-row",
                {
                  staticStyle: { "flex-wrap": "wrap" },
                  attrs: { type: "flex", justify: "left" },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 9 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("collectionCenter.val1") } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "95%" },
                            attrs: {
                              "default-time": ["00:00:00", "23:59:59"],
                              placeholder: _vm.$t("newOrder.SelectDatetime"),
                              "range-separator": "~",
                              size: "small",
                              type: "datetimerange",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            on: { change: _vm.changeTime },
                            model: {
                              value: _vm.timeValue,
                              callback: function ($$v) {
                                _vm.timeValue = $$v
                              },
                              expression: "timeValue",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "div",
                            { staticClass: "selectLabel" },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { size: "small" },
                                  on: { change: _vm.typeChange },
                                  model: {
                                    value: _vm.queryForm.params.searchType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm.params,
                                        "searchType",
                                        $$v
                                      )
                                    },
                                    expression: "queryForm.params.searchType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("newOrder.waybillNumber"),
                                      value: "waybill",
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("GlobalSetObj.ScanNumber"),
                                      value: "scan",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("el-input", {
                            staticClass: "inputClass",
                            staticStyle: { width: "95%" },
                            attrs: {
                              placeholder: _vm.$t("newOrder.PreciseSearch1"),
                              rows: 1,
                              type: "textarea",
                              clearable: "",
                            },
                            on: { blur: _vm.BlockNewline },
                            nativeOn: {
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.BlockNewline($event)
                              },
                            },
                            model: {
                              value: _vm.inputValue,
                              callback: function ($$v) {
                                _vm.inputValue = $$v
                              },
                              expression: "inputValue",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("collectionCenter.val3") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "95%" },
                              attrs: {
                                placeholder: _vm.$t("placeOrder.pleaseChoose"),
                                clearable: "",
                                filterable: "",
                                multiple: "",
                                "collapse-tags": "",
                                size: "small",
                              },
                              model: {
                                value: _vm.queryForm.params.operateRegionIds,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "operateRegionIds",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.operateRegionIds",
                              },
                            },
                            _vm._l(_vm.regionList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label:
                                    item.zhName + "（" + item.puName + "）",
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("collectionCenter.val4") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "95%" },
                              attrs: {
                                placeholder: _vm.$t("placeOrder.pleaseChoose"),
                                clearable: "",
                                filterable: "",
                                multiple: "",
                                "collapse-tags": "",
                                size: "small",
                              },
                              model: {
                                value: _vm.queryForm.params.operateSiteIds,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "operateSiteIds",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.operateSiteIds",
                              },
                            },
                            _vm._l(_vm.siteList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "20px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.search },
                },
                [_vm._v(_vm._s(_vm.$t("newOrder.search")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "info" },
                  on: { click: _vm.resetForm },
                },
                [_vm._v(_vm._s(_vm.$t("newOrder.reset")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.exportAll },
                },
                [_vm._v(_vm._s(_vm.$t("newOrder.export")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "header-cell-style": { background: "#f2f2f2", color: "black" },
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("operationCenter.ind"),
                  width: "60px",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              (_vm.queryForm.pageNumber - 1) *
                                _vm.queryForm.pageSize +
                                scope.$index +
                                1
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._l(_vm.tableHeaderList, function (item, index) {
                return _c(
                  "el-table-column",
                  {
                    key: index,
                    attrs: {
                      align: "center",
                      label: item.label,
                      "min-width": item.cloWidth,
                      prop: item.prop,
                      "show-overflow-tooltip": true,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    scope.row[item.prop]
                                      ? "" + scope.row[item.prop]
                                      : "--"
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [
                    _c("template", { slot: "header" }, [
                      item.prop === "remainingSlaTimeStr"
                        ? _c(
                            "div",
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("collectionCenter.val11"))
                                ),
                              ]),
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: _vm.$t("collectionCenter.val12"),
                                    placement: "top",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "deliveryTimesTips" },
                                    [_vm._v("?")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ],
                  2
                )
              }),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  "current-page": _vm.queryForm.pageNumber,
                  "page-size": _vm.queryForm.pageSize,
                  "page-sizes": [10, 20, 50, 100],
                  total: _vm.total,
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "size-change": _vm.search,
                  "current-change": _vm.searchPage,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }